import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleText',
})
export class RoleTextPipe implements PipeTransform {
    transform(value: string) {
        if (!value) {
            return '';
        }

        switch (value) {
            case 'AssistantPrincipal':
                return 'Assistant Principal';
            case 'AwardAdmin':
                return 'Award Administrator';
            case 'Counselor':
                return 'Counselor';
            case 'Designee':
                return 'Designee';
            case 'Developer':
                return 'Developer';
            case 'Judge':
                return 'Judge';
            case 'Nominee':
                return 'Nominee';
            case 'Principal':
                return 'Principal';
            case 'SystemAdmin':
                return 'System Administrator';
            case 'VolunteerCoordinator':
                return 'Volunteer Coordinator';
            default:
                return '';
        }
    }
}
